import { useEffect } from 'react'
import { rl } from '../copyRelease'
import { buttonClass } from './styles'

/**
 * Blind round 3 (tom, marco): the app's error screen. It was one line with no way out, and Back kept it. Now: Reload and
 * Go to Browse (both full page loads, which also fetch the newest build files after a deploy), and the browser's Back or
 * Forward leaves it: the page at the new address loads fresh (a screen file that failed stays failed inside one page
 * load, so re-rendering in place would show the error again). Lives outside the router (main.tsx), so plain links only.
 * main.tsx passes it as an element: Sentry's function fallback rendered nothing here (blind r3 repro, 10/15).
 */
export function Recovery() {
  useEffect(() => {
    const leave = () => location.reload()
    window.addEventListener('popstate', leave)
    return () => window.removeEventListener('popstate', leave)
  }, [])
  return (
    <main role="alert" data-review-id="app-error" className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center bg-bg px-5 py-10">
      <h1 className="t-title text-ink">{rl('rl.err_title')}</h1>
      <p className="t-body mt-2 text-ink-2">{rl('rl.err_body')}</p>
      <button type="button" data-review-id="app-error-reload" onClick={() => location.reload()} className={buttonClass('primary', 'lg', 'mt-6 w-full')}>{rl('rl.err_reload')}</button>
      <a href="/" data-review-id="app-error-browse" className="press t-label mt-3 inline-flex min-h-11 items-center justify-center text-ink underline underline-offset-4">{rl('rl.err_browse')}</a>
    </main>
  )
}
